/* Use Dawn cart/variant events; this component never modifies the cart. */
if (!customElements.get('lyma-product-shipping')) {
  customElements.define('lyma-product-shipping', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info') || this.closest('.shopify-section');
      if (!this.root) return;
      this.threshold = Number(this.dataset.threshold);
      this.cartTotal = Number(this.dataset.cartTotal);
      this.price = Number(this.dataset.price);
      this.pending = true;
      this.requestId = 0;
      this.onInput = (event) => {
        if (!event.target.matches('.lyma-buy-quantity .quantity__input')) return;
        this.pending = true;
        this.render();
      };
      this.root.addEventListener('input', this.onInput);
      this.root.addEventListener('change', this.onInput);
      this.unsubscribers = [
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          this.price = Number(data.variant?.price || 0);
          this.pending = true;
          this.render();
        }),
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.updateCart(event)),
      ];
      this.render();
    }

    disconnectedCallback() {
      this.requestId++;
      this.root?.removeEventListener('input', this.onInput);
      this.root?.removeEventListener('change', this.onInput);
      this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
    }

    async updateCart(event) {
      const variantId = this.root.querySelector('.product-variant-id')?.value;
      if (event.source === 'product-form' && String(event.productVariantId) === variantId) {
        this.pending = false;
      }
      const requestId = ++this.requestId;
      try {
        let cart = event.cartData;
        // Cart changes supply totals; add-to-cart responses only supply added items.
        if (typeof cart?.total_price !== 'number') {
          const response = await fetch(window.Shopify.routes.root + 'cart.js', {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          cart = await response.json();
        }
        if (!this.isConnected || requestId !== this.requestId) return;
        this.cartTotal = cart.total_price;
        this.render();
      } catch (_) {
        // Preserve the last known progress when the cart cannot be refreshed.
      }
    }

    render() {
      const quantity = Math.max(0, Number(this.root.querySelector('.lyma-buy-quantity .quantity__input')?.value) || 0);
      const total = Math.max(0, this.cartTotal + (this.pending ? this.price * quantity : 0));
      const remaining = Math.max(0, this.threshold - total);
      const progress = Math.min(100, Math.max(0, total / this.threshold * 100));
      const money = remaining % 100 === 0
        ? (remaining / 100).toLocaleString('nl-NL') + ',-'
        : (remaining / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.querySelector('[data-shipping-message]').textContent = remaining > 0
        ? 'Nog ' + money + ' tot gratis verzending'
        : 'Je hebt gratis verzending';
      this.querySelector('.lyma-product-shipping__fill').style.width = progress + '%';
    }
  });
}
